(function () {
  "use strict";

  function focusable(container) {
    return Array.from(container.querySelectorAll('a[href], button:not([disabled]), iframe, [tabindex]:not([tabindex="-1"])')).filter(function (item) {
      return !item.hidden && item.getAttribute("aria-hidden") !== "true";
    });
  }

  function init(root) {
    if (!root || root.dataset.drsknnTeamReady === "true") return;
    root.dataset.drsknnTeamReady = "true";

    var profileModal = root.querySelector("[data-team-profile-modal]");
    var profileDialog = root.querySelector("[data-team-profile-dialog]");
    var profilePanels = Array.from(root.querySelectorAll("[data-team-profile-panel]"));
    var bookingModal = root.querySelector("[data-team-booking-modal]");
    var bookingDialog = root.querySelector("[data-team-booking-dialog]");
    var bookingFrame = root.querySelector("[data-team-booking-frame]");
    var bookingChooser = root.querySelector("[data-team-booking-chooser]");
    var bookingPanel = root.querySelector("[data-team-booking-panel]");
    var activeModal = null;
    var activeDialog = null;
    var opener = null;
    var hideTimer = null;

    function setProfile(key) {
      var active = null;
      profilePanels.forEach(function (panel) {
        var show = panel.getAttribute("data-team-profile-panel") === key;
        panel.hidden = !show;
        if (show) active = panel;
      });
      if (active) {
        var heading = active.querySelector("h2");
        if (heading && heading.id) profileDialog.setAttribute("aria-labelledby", heading.id);
      }
    }

    function show(modal, dialog, trigger) {
      if (hideTimer) window.clearTimeout(hideTimer);
      opener = trigger || document.activeElement;
      activeModal = modal;
      activeDialog = dialog;
      modal.hidden = false;
      modal.setAttribute("aria-hidden", "false");
      document.body.classList.add("drsknn-team-v2-lock");
      window.requestAnimationFrame(function () {
        modal.classList.add("is-open");
        dialog.focus({ preventScroll: true });
      });
    }

    function close() {
      if (!activeModal || activeModal.hidden) return;
      var closing = activeModal;
      closing.classList.remove("is-open");
      closing.setAttribute("aria-hidden", "true");
      document.body.classList.remove("drsknn-team-v2-lock");
      activeModal = null;
      activeDialog = null;
      hideTimer = window.setTimeout(function () {
        closing.hidden = true;
        if (opener && typeof opener.focus === "function") opener.focus({ preventScroll: true });
      }, 180);
    }

    function bookingUrl(role) {
      var allowed = { doctor: true, nurse: true, practitioner: true };
      var slug = allowed[role] ? role : "doctor";
      var url = new URL("https://www.drsknn.uk/kiosk/v4/consultation/" + slug);
      var params = {
        source: "team_v2",
        landing_source: "drsknn_com_team_v2",
        campaign: "team_v2",
        landing_page: "meet_the_team",
        funnel_stage: "team_consultation",
        booking_mode: "consultation",
        clinician_role: slug,
        embed: "1",
        embedded: "1",
        booking_embed: "team_v2_modal",
        hide_cookie_banner: "1",
        hide_cookie_notice: "1",
        hide_iubenda: "1",
        skip_cookie_policy: "1",
        privacy_bypass: "1",
        kiosk_privacy_bypass: "1",
        cookie_consent: "accepted",
        consent: "accepted",
        iubenda_consent: "accepted",
        parent_domain: "drsknn.com",
        website_cookie_consent_status: "accepted_on_parent_site",
        website_cookie_consent_ref: "drsknn_com_iubenda"
      };
      Object.keys(params).forEach(function (key) { url.searchParams.set(key, params[key]); });
      return url.toString();
    }

    function showBookingChooser(recommendedRole) {
      if (bookingChooser) bookingChooser.hidden = false;
      if (bookingPanel) bookingPanel.hidden = true;
      root.querySelectorAll("[data-team-book-role]").forEach(function (button) {
        button.classList.toggle("is-recommended", button.getAttribute("data-team-book-role") === recommendedRole);
      });
    }

    function showBookingRole(role) {
      if (bookingChooser) bookingChooser.hidden = true;
      if (bookingPanel) bookingPanel.hidden = false;
      if (bookingFrame) bookingFrame.setAttribute("src", bookingUrl(role));
    }

    root.addEventListener("click", function (event) {
      var profileTrigger = event.target.closest("[data-team-profile-open]");
      if (profileTrigger) {
        setProfile(profileTrigger.getAttribute("data-team-profile-open"));
        show(profileModal, profileDialog, profileTrigger);
        return;
      }

      var bookingTrigger = event.target.closest("[data-team-booking-open]");
      if (bookingTrigger) {
        showBookingChooser(bookingTrigger.getAttribute("data-team-booking-open") || "");
        show(bookingModal, bookingDialog, bookingTrigger);
        return;
      }

      var roleTrigger = event.target.closest("[data-team-book-role]");
      if (roleTrigger) {
        showBookingRole(roleTrigger.getAttribute("data-team-book-role"));
        return;
      }

      if (event.target.closest("[data-team-booking-back]")) {
        showBookingChooser("");
        return;
      }

      if (event.target === profileModal || event.target.closest("[data-team-profile-close]") || event.target === bookingModal || event.target.closest("[data-team-booking-close]")) close();
    });

    document.addEventListener("keydown", function (event) {
      if (!activeDialog) return;
      if (event.key === "Escape") {
        event.preventDefault();
        close();
        return;
      }
      if (event.key !== "Tab") return;
      var items = focusable(activeDialog);
      if (!items.length) {
        event.preventDefault();
        activeDialog.focus();
        return;
      }
      var first = items[0];
      var last = items[items.length - 1];
      if (event.shiftKey && document.activeElement === first) {
        event.preventDefault();
        last.focus();
      } else if (!event.shiftKey && document.activeElement === last) {
        event.preventDefault();
        first.focus();
      }
    });
  }

  function boot() { document.querySelectorAll("[data-drsknn-team-v2]").forEach(init); }
  if (document.readyState === "loading") document.addEventListener("DOMContentLoaded", boot, { once: true });
  else boot();
  document.addEventListener("shopify:section:load", boot);
})();
